<ng-container>
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select formControlName="type">
        <mat-option *ngFor="let type of getTypes()" [value]="type.value">
          {{ type.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Condition</mat-label>
      <mat-select formControlName="condition">
        <mat-option *ngFor="let condition of getConditions()" [value]="condition.value">
          {{ condition.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="filterType !== 'age'">
      <mat-label>Values</mat-label>
      <mat-select formControlName="values" multiple>
        <mat-option *ngFor="let value of values" [value]="value.value">
          {{ value.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <app-list-input
      *ngIf="filterType === 'age' && acceptsMultipleValues()"
      formControlName="values"
      [label]="'Values'"
    />
    <mat-form-field *ngIf="filterType === 'age' && !acceptsMultipleValues()">
      <mat-label>Value</mat-label>
      <input matInput formControlName="values" />
    </mat-form-field>
  </form>
</ng-container>
